import { html, css } from 'lit-element';
import { TmnToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';
import { connect } from '../store/connect';
import { actions } from './';
import { selectors as userSelectors } from '../user';
import './admin-context-search';

class AdminContextTool extends TmnToolBase {
    constructor() {
        super();
    }

    static get properties() {
        return {
            activeAuthSite: {
                type: String,
            },
        };
    }

    static get styles() {
        return [
            super.styles,
            css`
                :host {
                    display: inline-flex;
                    user-select: none;
                    margin-left: 0px;
                }
                /*override color since this can be shown in header which switches the color */
                /* .menu-container {
                    color: #000;
                } */
                tmn-modal {
                    top: 0px;
                    overflow: auto;
                    height: 50vh;
                }
                tmn-button,
                tmn-select {
                    width: 100%;
                    max-height: 300px;
                    overflow: auto;
                }
                tmn-select {
                    color: #000000;
                }
                tmn-grid[item] {
                    width: 100%;
                }

                div[slot='main'] {
                    min-height: 135px;
                    padding-bottom: 2px;
                }
            `,
        ];
    }

    renderButtonContent() {
        const { activeAuthSite } = this;
        return activeAuthSite ? html`${activeAuthSite}` : html`[Select Site]`;
    }

    renderToolContent() {
        return html`<admin-context-search
            @tmn-routed-item-click=${this.closeOnRouteEvent}></admin-context-search>`;
    }

    closeOnRouteEvent(e) {
        // HACK: relying on routed event until we rework the table hierarchy
        if (this.open) {
            this._toggleDialog(e);
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const activeAuthSite = userSelectors.activeAuthSiteNameSelector(state);
        return {
            activeAuthSite,
        };
    };
};

customElements.define('admin-context-tool', connect(mapStateToProps, actions)(AdminContextTool));
